///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class EmployeesDataTemplate extends DataTemplateBase implements IDataTemplate {
        //protected employeeCategories: EmployeeCategoriesCollection;
        protected employees: EmployeesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection(): ICollectionBase<any> {
            return this.employees;
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        //get collection() {
        //    return this.employeeCategories;
        //}

        //get leafCollection() {
        //    return this.employees;
        //}

        //get totalSelectedCount(): number {
        //    return this.employees.value.length;
        //}

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);
            
            //this.employeeCategories = new EmployeeCategoriesCollection(this.model[properties[0]], [], {
            //    criteria
            //});
            this.employees = new EmployeesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: <ModelValueType[]>options.defaultValue
            });
            //this.employees.setParentCollection(this.employeeCategories, EmployeeToCategoriesStrategy);

            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES' }, this)
            ];
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_EMPLOYEE';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';
        }

        updateConnectedModels() {
            this.collection.connectedModel = this.model[this.properties[0]];
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.employees.setWatchers(scope);
        }
    }
}
